// Dynamic Type (DUE-420) for inline `font:` shorthands. Screens declare
// `font: "500 14px/21px var(--font-body)"` in px instead of using a `--t-*`
// role, so the `--t-scale` / `--t-scale-display` variables (written on :root by
// `lib/platform/textScale.ts`, default 1) never reach them. `scaledFont`
// rewrites the size and the leading as `calc(Npx * var(--t-scale…, 1))`.
// With both variables at 1 the result is the original px value.
//
// Sizes >= 26px are headings/display and follow `--t-scale-display`; the rest
// follows `--t-scale`. Not for `--t-tab` / `--t-chart` places.
const DISPLAY_MIN_PX = 26;

export function scaledFont(shorthand: string): string {
  const m = /^(\S+ )(\d+(?:\.\d+)?)px(?:\/(\d+(?:\.\d+)?)px)?(.*)$/.exec(shorthand);
  if (!m) throw new Error(`scaledFont: no "<weight> <N>px" in "${shorthand}"`);
  const [, weight, size, leading, rest] = m;
  const v = Number(size) >= DISPLAY_MIN_PX ? "var(--t-scale-display, 1)" : "var(--t-scale, 1)";
  const lead = leading ? `/calc(${leading}px * ${v})` : "";
  return `${weight}calc(${size}px * ${v})${lead}${rest}`;
}

/** Longhand variant for `fontSize` / `lineHeight` given as a px number. */
export function scaledPx(px: number): string {
  const v = px >= DISPLAY_MIN_PX ? "var(--t-scale-display, 1)" : "var(--t-scale, 1)";
  return `calc(${px}px * ${v})`;
}
